import React from "react";
import { Header } from '../../Components/Layout/Header.jsx'
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx'
import { MetaTags } from '../../Components/Layout/MetaTags.jsx'
import { ReCaptcha } from '../../Components/Shared/ReCaptcha.jsx'

export class KontaktPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            captchaResetKey: new Date(),
            formSuccess: false,
            ime: '',
            nadimak: '',
            email: '',
            kategorija: 'registracija',
            poruka: '',
            captchaKey: '',
            attachedFiles: [],
            attachedFileNames: [],
            attachedFilesBase64: [],
            uploadingFile: false,
            loading: false,
            validateIme: true,
            validateMail: true,
            validateNadimak: true,
            validatePoruka: true,
            validateCaptchaKey: true,
            emailWrongFormat: false,
            formError: false,
            formeErrorMessage: null,
            user: null,
            showInformacije: false,
        }

        this.updateCaptcha = this.updateCaptcha.bind(this);
        this.sendFromData = this.sendFromData.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.faqAttachmentPageModalRef = React.createRef();
        this.convertToBase64 = this.convertToBase64.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.loginFromOutside = this.loginFromOutside.bind(this);
        this.setData = this.setData.bind(this);
    }

    /**** LIFECYCLE METHODS *****/
    componentDidMount() {
        if (!casino.casinoConstants.igracSePromijenio)
            casino.casinoConstants.igracSePromijenio = [];

        //add callback method after login
        casino.casinoConstants.igracSePromijenio.push(this.loginFromOutside);

        this.setData();
    }
    /***************************/
    setData() {
        casino.repos.sessionRepo.get().then(result => {
            if (result.Igrac)
                this.setState({ user: result.Igrac });
        });
    }

    loginFromOutside(data) {
        this.setData();
    }

    sendFromData(event) {
        event.preventDefault();

        let newState = this.validateForm();

        if (!this.state.ime || !this.state.nadimak || !this.state.email || newState.emailWrongFormat || !this.state.kategorija || !this.state.poruka || !this.state.captchaKey) {
            this.setState(newState);
            return;
        }

        this.setState({ loading: true });

        const model = {
            ime: this.state.ime,
            nadimak: this.state.nadimak,
            email: this.state.email,
            kategorija: this.state.kategorija,
            poruka: this.state.poruka,
            captchaKey: this.state.captchaKey,
            attachedFiles: this.state.attachedFileNames
        };

        casino.repos.mailFormRepo.post(model).then((result) => {
            if (result.success) {
                this.setState({
                    formSuccess: true,
                    loading: false,
                    ime: '',
                    nadimak: '',
                    email: '',
                    kategorija: 'registracija',
                    poruka: '',
                    captchaKey: '',
                    attachedFiles: [],
                    attachedFileNames: []
                });
                setTimeout(() => { this.setState({ formSuccess: false }); }, 5000);
            } else {
                this.setState({ loading: false, formError: true, formeErrorMessage: result.message, formSuccess: false });
                setTimeout(() => { this.setState({ formError: false, formeErrorMessage: null }); }, 5000);
            }
        });
    }

    validateForm() {
        //Reset validation
        var newState = this.resetValidation();

        if (!this.state.ime)
            newState.validateIme = false;
        if (!this.state.email)
            newState.validateMail = false;
        if (this.state.email && !casino.utils.validateEmail(this.state.email))
            newState.emailWrongFormat = true;
        if (!this.state.nadimak)
            newState.validateNadimak = false;
        if (!this.state.poruka)
            newState.validatePoruka = false;
        if (!this.state.captchaKey)
            newState.validateCaptchaKey = false;

        return newState;
    }

    resetValidation() {
        return {
            validateIme: true,
            validateMail: true,
            validateNadimak: true,
            validatePoruka: true,
            emailWrongFormat: false,
            validateCaptchaKey: true,
        };
    }

    updateCaptcha(captcha = "") {
        this.setState({ captchaKey: captcha, validateCaptchaKey: true });
    }

    attachFile = (e) => {
        let file = e.target.files[0];
        let fileList = this.state.attachedFiles;
        let attachedFileNames = this.state.attachedFileNames;
        let fileTypes = ['image/png', 'image/jpeg', 'application/pdf', 'video/quicktime', 'video/mp4'];
        if (!file.name
            || fileList.filter(it => it.name == file.name).length > 0
            || fileTypes.filter(x => x == file.type).length == 0)
            return

        file.upload = true;

        fileList.push(file);
        this.convertToBase64(file, (fileObject) => {
            this.uploadFile(fileObject, (result) => {
                if (result.success) {
                    file.upload = false;
                    attachedFileNames.push(result.message);
                    this.setState({ attachedFileNames: attachedFileNames });
                }
            });
        });
        this.setState({ attachedFiles: fileList });
    }

    uploadFile(file, callback) {
        this.setState({ uploadingFile: true });
        casino.repos.fileUploadRepo.post(file).then((result) => {
            if (result.success)
                this.setState({ uploadingFile: false });
            callback(result);
        });
    }

    convertToBase64(file, callback) {
        let fileListBase64 = this.state.attachedFilesBase64;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            callback({ base64: reader.result, type: file.type, name: file.name });
        };
        reader.onerror = (error) => {
        };
    }

    removeFile(index) {
        let newArrayBase64 = this.state.attachedFilesBase64.filter((file, i) => i != index);
        let newArray = this.state.attachedFiles.filter((file, i) => i != index);
        let newAttachedFileNames = this.state.attachedFileNames.filter((fileName, i) => i != index);
        this.setState({ attachedFiles: newArray, attachedFilesBase64: newArrayBase64, attachedFileNames: newAttachedFileNames });
    }

    renderAttachedFiles() {
        return this.state.attachedFiles.map((file, i) =>
            <div key={"file" + i} className="document-name">
                <p className={((file.size / 1024) / 1024) >= 20.00 ? "document-file-error" : "document-file"}>{file.name}</p>
                <div className="document-right-side">
                    <span className={((file.size / 1024) / 1024) >= 20.00 ? "document-checkmark-error" : file.upload ? "document-loading" : "document-checkmark"} />
                    <p className={((file.size / 1024) / 1024) >= 20.00 ? "document-size-error" : "document-size"}>{((file.size / 1024) / 1024).toFixed(2) == 0.00 ? ((file.size / 1024) / 1024).toFixed(4) : ((file.size / 1024) / 1024).toFixed(2)}MB</p>
                    <p onClick={() => this.removeFile(i)} className="ukloni-dokument"></p>
                </div>
            </div>
        )
    }

    render() {
        return <div>
            <MetaTags title="Kontakt | SuperSport Casino | SuperCasino" description=" " />
            <Header key="header" {...this.state} {...this.props}></Header>

            <div id="page-wrapper" className="white faq-wrapper">
                {/*Informacije*/}
                {this.state.showInformacije && <div className="faq-container maximum margin-center" >
                    {this.renderInformacije()}
                </div>}

                <div className="form-container" style={{ border: "none", marginTop: "0" }}>
                    {!this.state.formSuccess && !this.state.loading && !this.state.formError && <h1>Trebaš pomoć? <span className="faq-red"> Kontaktiraj nas.</span></h1>}
                    {!this.state.formSuccess && <form onSubmit={this.sendFromData}>
                        <div className="faq-row">
                            <div className="row-form">
                                <p className="input-label">Ime {(!this.state.validateIme == '' ? '' : <span className="validation-text-error"> Obavezno polje!</span>)}</p>
                                <div className="input-container">
                                    <div className={"input-wrapper " + (this.state.validateIme == '' ? 'error' : '')}>
                                        <input className="input" type="text" value={this.state.ime} onChange={(e) => this.setState({ ime: e.target.value, validateIme: true })}></input>
                                    </div>
                                </div>
                                <p className="input-label">Nadimak {(!this.state.validateNadimak == '' ? '' : <span className="validation-text-error"> Obavezno polje!</span>)}</p>
                                <div className="input-container">
                                    <div className={"input-wrapper " + (this.state.validateNadimak == '' ? 'error' : '')}>
                                        <input className="input" type="text" value={this.state.nadimak} onChange={(e) => this.setState({ nadimak: e.target.value, validateNadimak: true })}></input>
                                    </div>
                                </div>
                                <div className="row-form">
                                    <p className="input-label">Mail{(this.state.validateMail == '' ? <span className="validation-text-error"> Obavezno polje!</span> : this.state.emailWrongFormat ? <span className="validation-text-error"> Polje je krivo popunjeno!</span> : '')}</p>
                                    <div className="input-container">
                                        <div className={"input-wrapper " + (this.state.validateMail == '' ? 'error' : '')}>
                                            <input className="input" type="text" value={this.state.email} onChange={(e) => this.setState({ email: e.target.value, validateMail: true, emailWrongFormat: false })}></input>
                                        </div>
                                    </div>
                                </div>
                                <p className="input-label">Kategorija</p>
                                <div className="input-container">
                                    <div className="input-wrapper">
                                        <select name="kategorije-faq" className="kategorije-faq" value={this.state.kategorija} onChange={(e) => this.setState({ kategorija: e.target.value })}>
                                            <option value="registracija">Registracija</option>
                                            <option value="racun">Račun</option>
                                            <option value="uplate">Uplate</option>
                                            <option value="isplate">Isplate</option>
                                            <option value="promocije">Promocije</option>
                                            <option value="casino">Casino</option>
                                            <option value="kladionica">Kladionica</option>
                                            <option value="ostalo">Ostalo</option>
                                            <option value="pomoc">Pomoć</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="poruka-faq">
                            <p className="input-label">Poruka {(!this.state.validatePoruka == '' ? '' : <span className="validation-text-error"> Obavezno polje!</span>)}</p>
                            <div className="input-container">
                                <div className={"input-wrapper " + (this.state.validatePoruka == '' ? 'error' : '')}>
                                    <textarea className="input" placeholder="Upiši poruku ovdje..." value={this.state.poruka} onChange={(e) => this.setState({ poruka: e.target.value, validatePoruka: true })}></textarea>
                                </div>
                            </div>
                        </div>
                        {this.state.attachedFiles.filter(file => ((file.size / 1024) / 1024) >= 20.00).length > 1 ? <p className="error-message">Označeni dokumenti se neću poslati!</p> : this.state.attachedFiles.filter(file => ((file.size / 1024) / 1024) >= 20.00).length > 0 && <p className="error-message"> Dokument: {this.state.attachedFiles.filter(file => ((file.size / 1024) / 1024) >= 20.00)[0].name} se neće poslati</p>}
                        {this.state.attachedFiles.map(file => ((file.size / 1024) / 1024)).reduce((prev, curr) => prev + curr, 0) > 30 && <p className="error-message">Ukupna veličina priloženih datoteka je prevelika!</p>}
                        <p className="attachment-size">Max. dopuštena ukupna veličina dokumenata do  <b>20MB</b></p>
                        <p className="text-grey">Možete dodati dokument u formatu: .jpeg, .png, .pdf, .mp4 i .mov</p>
                        {this.state.attachedFiles.length > 0 && <div className="form-attachments">
                            <div className="attachments-documents">
                                {this.renderAttachedFiles()}
                            </div>
                        </div>}
                        <div className="form-buttons">
                            <div>
                                <label className="privitak-faq">
                                    <input className="privitak-hidden" type="file" onChange={(e) => this.attachFile(e)} /><span className="privitak-tekst">DODAJ PRIVITAK</span></label>
                                <button type="submit" className="posalji-privitak"
                                    disabled={(this.state.uploadingFile || (this.state.attachedFiles.map(file => ((file.size / 1024) / 1024)).reduce((prev, curr) => prev + curr, 0) > 30 ||
                                        this.state.attachedFiles.filter(file => ((file.size / 1024) / 1024) >= 20.00).length > 0) ? true : false)} >POŠALJI
                                </button>
                            </div>
                        </div>
                        <ReCaptcha className="captcha" key={this.state.captchaResetKey} updateCaptchaFn={this.updateCaptcha}></ReCaptcha>
                        {(this.state.validateCaptchaKey ? '' : <p className="captcha-error">Molimo ispunite verifikaciju!</p>)}
                    </form>}
                    {!this.state.formSuccess && this.state.loading && !this.state.formError && <div className="message-uploading">
                        <div className="spining-loader">
                        </div>
                        <div className="message">
                            {this.state.attachedFiles.length > 0 ? <p>Datoteke se učitavaju. <br />Molimo pričekajte...</p> : <p>Poruka se šalje. <br />Molimo pričekajte...</p>}
                        </div>
                    </div>}
                    {!this.state.formError && this.state.formSuccess && !this.state.loading && <div className="message-send">
                        <div className="circle-checkmark">
                        </div>
                        <div className="message">
                            <p><span className="green-text">Tvoj upit je uspješno poslan.</span><br />
                                Potruditi ćemo se da ti se povratno javimo u najkraćem <br />
                                mogućem roku.</p>
                        </div>
                    </div>}
                    {this.state.formError && !this.state.loading && !this.state.formSuccess && <div className="message-send">
                        <div className="circle-checkmark-error">
                        </div>
                        <div className="message">
                            <p><span className="red-text">Dogodila se greška.</span><br />{this.state.formeErrorMessage && <span className="error-message">{this.state.formeErrorMessage}</span>}</p>
                        </div>
                    </div>}
                </div>
            </div>
            <ObavijestiCasino {...this.props}></ObavijestiCasino>
        </div>
    }
}